import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { CustomSortIcon } from "../../../components/DatatableHelpers";
import { PeerReviewGroupRowActions } from "../PeerReviewGroupRowActions";
import { ReviewGroupWriterModel } from "../peerReviewGroupsApiSlice";
import { CoursePromptReviewGroup } from "./coursePromptReviewGroupsApiSlice";
import { makeNameString } from "./coursePromptGroupsUtil";

interface CoursePromptGroupsTableProps {
	groups: CoursePromptReviewGroup[];
	allWriters: ReviewGroupWriterModel[];
	availablePool: ReviewGroupWriterModel[];
	poolVersion: number;
	canChangeGroups: boolean;
	onEditCoursePromptGroup: (newGroup: CoursePromptReviewGroup) => void;
	removeCoursePromptGroup: (uniqueId: string) => void;
}

export default function CoursePromptGroupsTable(props: CoursePromptGroupsTableProps) {
	const studentNamesBodyTemplate = (row: CoursePromptReviewGroup) => {
		const matchingNames = row.studentIds.map((id) => {
			const student = props.allWriters.find((item) => item.id === id);
			return student ? student.fullName : "Unknown";
		});

		return <p>{matchingNames?.join(", ")}</p>;
	};

	const studentsSortFunction = (event: any) => {
		const data = [...event.data];
		data.sort((data1, data2) => {
			const names1 = makeNameString(data1, props.allWriters).toLowerCase();
			const names2 = makeNameString(data2, props.allWriters).toLowerCase();

			return names1.localeCompare(names2) * event.order;
		});
		return data;
	};

	const actionBodyTemplate = (row: CoursePromptReviewGroup) => {
		const groupPool = row.studentIds.map((studentId) => {
			return props.allWriters.find((item) => item.id === studentId);
		});
		const fullPool = [
			...props.availablePool,
			...groupPool.filter((writer) => writer !== undefined),
		].sort((a, b) => a.fullName.localeCompare(b.fullName));

		return (
			<PeerReviewGroupRowActions
				rowId={row.uniqueId}
				rowName={row.name}
				coursePromptGroup={row}
				availablePool={fullPool}
				onEditCoursePromptGroup={props.onEditCoursePromptGroup}
				onRemoveCoursePromptGroup={props.removeCoursePromptGroup}
			/>
		);
	};

	return (
		<DataTable
			value={props.groups}
			dataKey="uniqueId"
			loading={props.groups == undefined}
			emptyMessage="No prompt review groups created"
			stripedRows
			sortIcon={CustomSortIcon}
			className="tbl tbl-data tbl-datatable min-w-[40rem] cursor-default"
			style={{ paddingTop: "16px" }}
			key={props.poolVersion}>
			<Column header="Group Name" field="name" sortable></Column>
			<Column
				header="Students"
				field="studentIds"
				body={studentNamesBodyTemplate}
				sortable
				sortFunction={studentsSortFunction}></Column>
			{props.canChangeGroups && (
				<Column body={actionBodyTemplate} className="w-8 !pl-1 !pr-2"></Column>
			)}
		</DataTable>
	);
}
